/// <amd-module name="Analytics/Boards/CumulativeFlowDiagramQueries/BoardSwimlaneQuery" />
import { AnalyticsCacheableQueryBase } from "Analytics/Common/AnalyticsCacheableQueryBase";
import { ODataQueryOptions } from "Analytics/Common/ODataQueryOptions";
import { latestODataVersion } from "Analytics/Common/Utilities/QueryUtilities";

export interface BoardSwimlane {
    LaneId: string;
    LaneName: string;
    IsDefaultLane: boolean;
    LaneOrder: number;
}

/**
 * Retrieves a set of current Kanban Swimlanes used by the selected team in a given board.
 * @param project ID or name of a project.
 * @param teamId ID of a board within the given project.
 */
export class BoardSwimlaneQuery extends AnalyticsCacheableQueryBase<BoardSwimlane[]> {
    private static generateQueryOptions(project: string, boardId: string): ODataQueryOptions {
        return {
            entityType: "BoardLocations",
            oDataVersion: latestODataVersion,
            project: project,
            $apply: `filter(BoardId eq ${boardId} and IsCurrent eq true)` + "/groupby((LaneId,LaneName,IsDefaultLane,LaneOrder))",
            $orderby: "LaneOrder"
        };
    }

    constructor(command: string, project: string, boardId: string) {
        super(command, BoardSwimlaneQuery.generateQueryOptions(project, boardId));
    }

    public getQueryName(): string {
        return "BoardSwimlaneQuery";
    }
}
